// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:59:40

export default {
  "id": "real-car-parking-and-stunt",
  "slug": "real-car-parking-and-stunt",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d6e56cc236f7472f825565816eb50193-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d6e56cc236f7472f825565816eb50193/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Real Car Parking And Stunt",
      "description": "Welcome to Real Car Parking And Stunt, a challenging driving simulation game. Here you’ll control a car and put your parking and stunt skills to the test. Choose stunt mode or parking mode, each level challenges you to park your car accurately while performing exciting stunts.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual",
        "Simulation"
      ],
      "tags": [
        "challenge",
        "parking",
        "skill",
        "stunts"
      ]
    },
    "zh-CN": {
      "title": "真实汽车停车与特技",
      "description": "欢迎来到真实汽车停车与特技，一款充满挑战的驾驶模拟游戏。在这里，您将控制一辆汽车，检验您的停车和特技技巧。选择特技模式或停车模式，每个关卡都挑战您在执行精彩特技的同时准确停车。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "模拟"
      ],
      "tags": [
        "挑战",
        "停车",
        "技巧",
        "特技"
      ]
    },
    "zh-TW": {
      "title": "真實汽車停車與特技秀",
      "description": "歡迎來到《真實汽車停車與特技》，一款挑戰性的駕駛模擬遊戲。在這裡，您將操控汽車，並測試您的停車和特技技巧。選擇特技模式或停車模式，每個關卡都挑戰您在進行刺激的特技時精準停車。",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "休闲",
        "模擬"
      ],
      "tags": [
        "挑戰",
        "停車",
        "技巧",
        "特技"
      ]
    },
    "zh-HK": {
      "title": "真實汽車停車及特技表演",
      "description": "歡迎來到《真實汽車停車及特技》，一款挑戰性高的駕駛模擬遊戲。在這裡，您將操控汽車，並測試您的停車及特技技巧。選擇特技模式或停車模式，每個關卡都將挑戰您在進行刺激特技的同時，準確停車。",
      "instructions": "滑鼠點擊或觸碰開始遊戲",
      "genres": [
        "輕鬆遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "挑戰",
        "停車",
        "技巧",
        "特技"
      ]
    },
    "ja": {
      "title": "リアルカー・パーキング アンド スタント",
      "description": "リアルカー・パーキング アンド スタントへようこそ、挑戦的な運転シミュレーションゲームです。ここでは、車を操縦し、駐車とスタントのスキルを試みることができます。スタントモードまたは駐車モードを選んでください、それぞれのレベルでは、車を正確に駐車しながら興味深いスタントを表演することを課します。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "カジュアル",
        "シミュレーション"
      ],
      "tags": [
        "挑戦",
        "駐車",
        "スキル",
        "スタント"
      ]
    },
    "ko": {
      "title": "실제 자동차 주차 및 스타unt",
      "description": "안녕하세요, 도전적인 드라이빙 시뮬레이션 게임 'Real Car Parking And Stunt'에 오신 것을 환영합니다. 여기서 차를 제어하여 주차 및 스타일트 캔들링 기술을 테스트하세요. 스타일트 모드나 주차 모드를 선택하세요. 각 레벨은 차를 정확하게 주차하면서 흥미로운 스타일트를 수행하도록 도전합니다.",
      "instructions": "마우스 클릭 또는 탭하여 게임 시작",
      "genres": [
        "캐주얼",
        "시뮬레이션"
      ],
      "tags": [
        "挑戦",
        "주차",
        "기술",
        "스타일"
      ]
    },
    "fr": {
      "title": "Parking et Stunt de Voiture Réelle",
      "description": "Bienvenue dans Real Car Parking And Stunt, un jeu de simulation de conduite défiant. Ici, vous contrôlerez une voiture et mettrez vos compétences en stationnement et en figures de cirque à l'épreuve. Choisissez le mode figures de cirque ou le mode stationnement, chaque niveau vous challenge à stationner votre voiture précisément tout en exécutant des figures de cirque captivantes.",
      "instructions": "Clic ou appui souris pour jouer",
      "genres": [
        "Facile",
        "Simulation"
      ],
      "tags": [
        "défis",
        "stationnement",
        "compétence",
        "figures d'acrobatie"
      ]
    }
  }
};
